// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"fa19e11e","648":"8882d0e0"}[chunkId] + ".chunk.js";
};